import { AgGridReact } from 'ag-grid-react';
import { Button, Modal } from 'antd';
// import React, { useEffect, useState } from 'react';
import React, { useEffect, useState , useRef} from 'react';
import axios from 'axios';
import { API_ENDPOINT_GET_CC_DATA, API_ENDPOINT_REMOVE_CC,API_ENDPOINT_CC_DETAILS } from '../vendorfollowup.constants';
import AddCCModal from './AddCCModal';
import { ExclamationCircleOutlined } from "@ant-design/icons";

const CCDetailsTable = () => {
    const [rowData, setRowData] = useState(null)
    const [editData, setEditData] = useState(null);
    const [ccId, setccId] = useState(null)
    const [ccList, setCCList] = useState([])
    const [showPopup, setShowPopup] = useState(false);
    const [popupMessage, setPopupMessage] = useState("");
    const fetchUserData = async () => {
        const authToken = localStorage.getItem("token");
    
        if (!authToken) {
            alert("Authentication token not found.");
            return;
        }
    
        try {
            const currentWorkspace = localStorage.getItem("currentWorkspace");
    
            // Call fetchCCList to fetch data from the new API
            const response = await axios.post(API_ENDPOINT_CC_DETAILS, {
                workspaceid: currentWorkspace,
            });
    
            if (Array.isArray(response.data.data) && response.data.data.length > 0) {
                // Process the fetched data and set it to rowData
                const formattedData = response.data.data.map((item) => ({
                    name: item.name,
                    email: item.email,
                    vendors: item.vendors || "",  // Ensure vendors is a string (or empty)
                    _id: item._id,  // Ensure _id is passed for further use
                }));
                
                // Update state for rowData
                setRowData(formattedData);
            } else {
                console.error("No data fetched in CC list");
                setRowData([]); // Set to empty if no data is found
            }
    
        } catch (error) {
            console.error("Error fetching user data:", error);
        }
    };
    
    useEffect(()=>{
        fetchUserData()

    }, [])
    const columnDefs = [
        { headerName: "Name", field: "name", },
        { headerName: "Email Id", field: "email" },
        { headerName: "Vendors", field: "vendors" },
        {
            headerName: "Action", field: "action", cellRenderer: (params) => {
                console.log(params.data, "params")
                return (
                    <>
                    <div style={{display:'flex', gap:'5px'}}>
                    <Button style={{ width: "150px", fontSize: "12px", color: "#0A8394", border: "1px solid #0A8394", borderRadius: "4px", padding: "4px 2px 4px 2px" }} onClick={() => handleEditClick(params.data)}>Edit <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.77051 5.83343H5.93717C5.49515 5.83343 5.07122 6.00903 4.75866 6.32159C4.4461 6.63415 4.27051 7.05807 4.27051 7.5001V15.0001C4.27051 15.4421 4.4461 15.8661 4.75866 16.1786C5.07122 16.4912 5.49515 16.6668 5.93717 16.6668H13.4372C13.8792 16.6668 14.3031 16.4912 14.6157 16.1786C14.9282 15.8661 15.1038 15.4421 15.1038 15.0001V14.1668M14.2705 4.16677L16.7705 6.66677M17.9247 5.48759C18.2529 5.15938 18.4373 4.71424 18.4373 4.25009C18.4373 3.78594 18.2529 3.34079 17.9247 3.01259C17.5965 2.68438 17.1513 2.5 16.6872 2.5C16.223 2.5 15.7779 2.68438 15.4497 3.01259L8.43717 10.0001V12.5001H10.9372L17.9247 5.48759Z" stroke="#0A8394" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                        </Button>
                        <Button
                            style={{
                                width: "150px",
                                fontSize: "12px",
                                backgroundColor: "#0A8394",
                                color: "#FFFFFF",
                            }}
                            onClick={() => handleClick(params.data)} // Pass relevant ccData
                        >
                            Delete
                            <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M4.14551 5.83333H17.4788M9.14551 9.16667V14.1667M12.4788 9.16667V14.1667M4.97884 5.83333L5.81217 15.8333C5.81217 16.2754 5.98777 16.6993 6.30033 17.0118C6.61289 17.3244 7.03681 17.5 7.47884 17.5H14.1455C14.5875 17.5 15.0115 17.3244 15.324 17.0118C15.6366 16.6993 15.8122 16.2754 15.8122 15.8333L16.6455 5.83333M8.31217 5.83333V3.33333C8.31217 3.11232 8.39997 2.90036 8.55625 2.74408C8.71253 2.5878 8.92449 2.5 9.14551 2.5H12.4788C12.6999 2.5 12.9118 2.5878 13.0681 2.74408C13.2244 2.90036 13.3122 3.11232 13.3122 3.33333V5.83333" stroke="white" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                        </Button> 
                    </div>
                           
                    </>
                )
            }
        }
    ];

    const [isAddCCModalVisible, setAddCCModalVisible] = useState(false);

    const handleAddCCSuccess = (newRow) => {
     

        // Do something with the new row, e.g., update a table
        console.log("New CC Added:", newRow);
    };
   
    const handleEditClick = (ccData) => {
        console.log("Inside handle edit click", ccData)
        setEditData(ccData);       // sets the selected row's data
        setAddCCModalVisible(true);     // opens the modal
        setccId(ccData._id);        // assuming 'id' is the unique identifier for the CC
    };
    const defaultColDef = {
        filter: true,
        floatingFilter: true,
        sortable: true,
        resizable: true,
        enableRowGroup: true,
        floatingFilter: true,
        flex: 1,
        filter: 'agTextColumnFilter',
    };

    console.log(ccId,"ccid check in the table")


    const handleRemoveCC = async (ccData) => {
        const authToken = localStorage.getItem("token");
        const currentWorkspace = localStorage.getItem("currentWorkspace");

        console.log("Workspace ID:", currentWorkspace);
        console.log("Email:", ccData.email);

        if (!authToken) {
            alert("Authentication token not found.");
            return;
        }

        try {
            // Assumes your new endpoint is '/remove-cc' and expects query params for workspace and email
            const response = await axios.delete(
                //API_ENDPOINT_REMOVE_CC,
                API_ENDPOINT_REMOVE_CC,
                {
                    headers: { Authorization: `Bearer ${authToken}` },
                    params: {
                        workspaceid: currentWorkspace,
                        email: ccData.email,
                    },
                }
            );

            if (response.data.status) {
                // Update the grid by filtering out the removed CC
                setRowData(prevData => prevData.filter(row => row.email !== ccData.email));
                // Optionally, show a success popup
                setPopupMessage("CC Removed Successfully!"); // Set remove success message
                setShowPopup(true);
            } else {
                console.error("Failed to remove CC: ", response.data.message);
            }
        } catch (error) {
            console.error("Error removing CC: ", error);
        }
    };

    const handleClick = (ccData) => {
        Modal.confirm({
            title: "Confirm Removal",
            content: "Are you sure you want to remove this vendor?",
            icon: <ExclamationCircleOutlined style={{ color: "#0A8394" }} />,
            okText: "Yes",
            cancelText: "No",
            okButtonProps: {
                style: { backgroundColor: "#0A8394", color: "white", border: "none" },
            },
            cancelButtonProps: {
                style: { backgroundColor: "white", color: "#0A8394", border: "1px solid #0A8394" },
            },
            onOk: () => handleRemoveCC(ccData), // replace with your actual remove logic
        });
    };



    return (
        <div className="ag-theme-alpine" style={{ height: "89vh",width:'100%' }}>
            <AgGridReact
                columnDefs={columnDefs}
                rowData={rowData}
                rowGroupPanelShow='always'
                defaultColDef={defaultColDef}
                rowHeight={50}
                rowWidth={50}
            // domLayout="autoHeight" 
            />
            <AddCCModal
                        visible={isAddCCModalVisible}
                        onClose={() => {
                            setAddCCModalVisible(false);
                            setEditData(null); // <--- this is important
                          }}
                        onSuccess={handleAddCCSuccess}
                        initialData={editData}
                        ccId={ccId} // Pass the ccId to the modal
                    />
        </div>
    );
};

export default CCDetailsTable;
